<script setup lang="ts">
import { ref } from "vue";
import { BaziPredictionRequest, BaziResponse } from "@/types/calculators";
import { fetchBaziPrediction } from "@/api/calculators";
import BaziPredictionForm from "@/views/Calculators/BaZiPrediction/components/BaziPredictionForm.vue";
import BaziPredictionResult from "@/views/Calculators/BaZiPrediction/components/BaziPredictionResult.vue";
import PageTitleWithBackButton from "@/components/PageTitleWithBackButton.vue";
import { useI18n } from "vue-i18n";
import AccordionFaq from "@/components/accordion/AccordionFAQ.vue";

const { t } = useI18n();

const baziResponse = ref<BaziResponse | null>(null);
const inputYear = ref<number | null>(null);
const apiLoading = ref(false);

async function loadBaziPrediction(baziRequest: BaziPredictionRequest) {
  if (apiLoading.value) {
    return;
  }
  apiLoading.value = true;
  try {
    baziResponse.value = await fetchBaziPrediction(baziRequest);
    inputYear.value = new Date(baziRequest.date).getFullYear();
  } finally {
    apiLoading.value = false;
  }
}
</script>

<template>
  <div
    class="w-full h-full overflow-y-auto no-scrollbar pt-6 xl:pt-[104px] max-md:bg-beige flex flex-col items-center px-4"
  >
    <div class="w-full lg:w-[812px]">
      <PageTitleWithBackButton
        :page-title="t('calculators.bazi.title')"
        :title-align="'left'"
        :class="{ 'xl:!flex': baziResponse }"
        :on-back="() => (baziResponse = null)"
      />
      <BaziPredictionResult
        v-if="baziResponse"
        :data="baziResponse"
        :input-year="inputYear"
      />
      <BaziPredictionForm
        v-else
        :loading="apiLoading"
        @submit="loadBaziPrediction"
      />
    </div>
    <div class="py-6 w-full lg:w-[812px]">
      <AccordionFaq
        faqTemplateName="faq.bazi.content"
        title="FAQ"
        :collapseButtonText="t('faq.bazi.collapse-button')"
      />
    </div>
  </div>
</template>
